import React from "react";

function ConfirmationPopupAdaptive({ setPopupOpen, isEndedAssessment }) {
    return (
        <div className="successful_create_transprant_body modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <img className="prereadLoader" src="/images/alert.svg" alt="icon" style={{ width: "60px", height: "60px", margin: "auto" }} />
                    </div>
                    <div className="modal-body" style={{ fontSize: "18px", textAlign: "center", fontWeight: "500" }}>
                        {isEndedAssessment ? "The assessment period has ended.\n Please contact the teacher for further assistance." : 'Unavailable for Adaptive Assessment!!'}
                    </div>
                    <hr style={{ margin: "15px 0px" }} />
                    <div className="p-2">
                        <button type="button" className="btn btn-secondary" style={{ float: "right" }} onClick={() => {
                            setPopupOpen(false)
                        }}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationPopupAdaptive;
